<template>
    <div class="composer-menu-area">
        <journey-builder-menu-brick-composer
            @add-brick="$emit('add-brick', $event)"
        >
        </journey-builder-menu-brick-composer>
        
        <!--  $emit('update:journeyStartDate', $event) -->
        
        <journey-builder-menu-edit-form
            ref="editForm"
                
            :journey-name="journeyName"
            :journey-world="journeyWorld"
            :journey-description="journeyDescription"
            :journey-start-date="journeyStartDate"
            :journey-end-date="journeyEndDate"
            :journey-is-active="journeyIsActive"
            :journey-division-id="journeyDivisionId"
            
            v-on:update:journeyName="$emit('update:journeyName', $event)"
            v-on:update:journeyWorld="$emit('update:journeyWorld', $event)"
            v-on:update:journeyDescription="$emit('update:journeyDescription', $event)"
            v-on:update:journeyStartDate="$emit('update:journeyStartDate', $event)"
            v-on:update:journeyEndDate="$emit('update:journeyEndDate', $event)"
            v-on:update:journeyIsActive="$emit('update:journeyIsActive', $event)"
            v-on:update:journeyDivisionId="$emit('update:journeyDivisionId', $event)"
        >    
        </journey-builder-menu-edit-form>

        <div class="button-area">
            <button :class="{ disabled: !isValidForm }" type="submit" class="btn btn-primary btn-save" @click="saveClick" v-if="showSaveButton">
                <i class="fa fa-save"/>{{resource('JourneyBuilder_Index_SaveButton_DisplayText')}}
            </button>
            
            <button :class="{ disabled: !isValidForm }" type="submit" class="btn btn-primary btn-unlock" @click="unlockClick" v-if="showUnlockButton">
                <i class="fa fa-lock"/>{{resource('JourneyBuilder_Shared_UnlockButton_DisplayText')}}
            </button>

            <button class="btn btn-primary ml-2" @click="cloneClick" v-if="showCloneButton">
                <i class="fas fa-clone"/> {{resource('JourneyBuilder_Shared_CloneButton_DisplayText')}}
            </button>
        </div>
    </div>
</template>

<script>
    import resourceMixin from "../../../../Util/Mixins/resources";
    import permissionsMixin from '../../Mixins/journey-permissions';
    
    import JourneyBuilderMenuBrickComposer from "./JourneyBuilderMenuBrickComposer.vue";
    import JourneyBuilderMenuEditForm from "./JourneyBuilderMenuEditForm.vue";
    import Modal from '../../../../Components/Util/Modal.vue';
    
    export default {
        name: 'journey-composer-menu',
        components: {
            JourneyBuilderMenuBrickComposer,
            JourneyBuilderMenuEditForm,
            Modal
        },
        mixins: [resourceMixin, permissionsMixin],
        methods: {
            saveClick(){
                if(!this.isValidForm){
                    return;
                }

                this.$emit('save');
            },
            unlockClick(){
                if(!this.isValidForm){
                    return;
                }

                this.$emit('unlock');
            },
            cloneClick(){
                this.$emit('clone');
            }
        },
        computed: {
            isValidForm(){
                //Form still needs to render
                if(!this.$refs.editForm){
                    return false;
                }
                
                return !this.$refs.editForm.$v.$invalid;
            },
            showSaveButton(){
                return this.canWrite;
                // return this.canWrite && !this.isLocked;
            },
            showUnlockButton(){
                //TODO: Implement locking/unlocking of journeys
                return false;
                // return this.canWrite && this.isLocked;
            },
            showCloneButton(){
                //Having an id  and write permissions means a journey can be cloned
                return !!this.journeyId && this.hasWritePermission;
            }
            // showLockButton(){
            //     return this.canWrite && !this.isLocked; 
            // },
            // showUnlockButton(){
            //     return this.canWrite && this.isLocked;
            // }
        },
        props: {
            journeyId: null,
            
            journeyName: '',
            journeyWorld: '',
            journeyDescription: '',
            journeyStartDate: null,
            journeyEndDate: null,
            journeyIsActive: true,
            journeyDivisionId: undefined
        }
    }
</script>

<style scoped src="../../Style/journey-builder-menu-brick-composer.scss" lang="scss"/>